// SVG icons helper

export const ExcelIcon = (props) => {
    let ts = String(Date.now()),
        gradients = {};

    for (let i = 0; i <= 3; i++) {
        gradients[i] = 'gradient-' + ts + '-' + i;        
    }
    
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={props?.size || 26} viewBox="0 0 13.546667 13.546667" height={props?.size || 26} {...props}>
            <defs>
                <linearGradient id={gradients[3]} x1="-166.63" y1="14.926" x2="-158.09" y2="-11.742" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#fff" />
                    <stop offset="1" stopColor="#fff" />
                </linearGradient>
                <linearGradient id={gradients[2]} gradientUnits="userSpaceOnUse" y1="32.738" x2="0" y2="-34.996">
                    <stop stopColor={props?.color1 || '#3A6F36'} />
                    <stop offset="1" stopColor={props?.color1 || '#3A6F36'} />
                </linearGradient>
                <linearGradient id={gradients[0]} gradientUnits="userSpaceOnUse" y1="30.389" x2="0" y2="-26.06">
                    <stop stopColor={props?.color2 || '#529C50'} />
                    <stop offset="1" stopColor={props?.color2 || '#529C50'} />
                </linearGradient>
                <linearGradient id={gradients[1]} x1="-475.47" y1="80.49" x2="-475.25" y2="-68.12"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#fff" />
                    <stop offset="1" stopColor="#fff" />
                </linearGradient>
            </defs>
            <g transform="matrix(.18741 0 0 .18741 35.12 6.367)">
                <rect width="35.28" height="55.831" x="-152.68" y="-25.442"
                    colorInterpolationFilters="linearRGB" color="#000"
                    imageRendering="auto" colorRendering="auto" fillRule="evenodd" isolation="auto"
                    colorInterpolation="sRGB" fill={'url(#' + gradients[0] + ')'} shapeRendering="auto"
                    rx="1.411" strokeWidth="1" />
                <path transform="scale(.28222)"
                    d="m-519.24-66.42v20.19h42.18v-20.19h-42.18m46.36 0v20.19h42.18v-20.19h-42.18m-46.36 31.732v20.19h42.18v-20.19h-42.18m46.36 0v20.19h42.18v-20.19h-42.18m-46.36 31.732v20.19h42.18v-20.19h-42.18m46.36 0v20.19h42.18v-20.19h-42.18m-46.36 31.732v20.19h42.18v-20.19h-42.18m46.36 0v20.19h42.18v-20.19h-42.18m-46.36 31.732v20.19h42.18v-20.19h-42.18m46.36 0v20.19h42.18v-20.19h-42.18"
                    fill={'url(#' + gradients[1] + ')'} />
                <g>
                    <path
                        d="m-425.03-26.529l40.922-7.902c.768-.148 1.411.629 1.411 1.411v69.43c0 .782-.644 1.559-1.411 1.411l-40.922-7.902c-.768-.148-1.411-.629-1.411-1.411v-53.622c0-.782.644-1.263 1.411-1.411"
                        transform="translate(241.3.474)" 
                        colorInterpolationFilters="linearRGB" color="#000" imageRendering="auto"
                        colorRendering="auto" fillRule="evenodd" isolation="auto"
                        colorInterpolation="sRGB" fill={'url(#' + gradients[2] + ')'} shapeRendering="auto" />
                    <path
                        d="m-160.61-11.864c1.988-.141 3.986-.264 5.983-.361-2.349 4.813-4.707 9.625-7.1 14.421 2.42 4.927 4.892 9.819 7.32 14.746-2.12-.123-4.232-.255-6.352-.405-1.496-3.669-3.317-7.215-4.39-11.05-1.197 3.572-2.903 6.942-4.276 10.444-1.927-.026-3.854-.106-5.781-.185 2.261-4.426 4.443-8.886 6.775-13.286-1.98-4.531-4.153-8.974-6.194-13.479 1.936-.114 3.871-.229 5.807-.334 1.311 3.44 2.745 6.836 3.827 10.364 1.161-3.739 2.895-7.259 4.382-10.875"
                        fill={'url(#' + gradients[3] + ')'} />
                </g>
            </g>
        </svg>
    );
};